"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class Tracker {
    constructor(spaceId, applicationName, options) {
        this.functionUrls = {
            direct: 'https://northamerica-northeast2-site-builder-119d31d1.cloudfunctions.net/contentful-logging-function',
            local: 'http://localhost:4000',
            proxy: 'https://contentful.telus.digital/contentful-logging-function'
        };
        this.spaceId = spaceId;
        this.applicationName = applicationName;
        this.options = options || {};
        if (this.options.sampleRate !== undefined) {
            this.sampleRate = this.options.sampleRate;
        }
        else {
            this.sampleRate = 1;
        }
        if (this.options.functionUrl !== undefined) {
            this.composedUrl = this.functionUrls[this.options.functionUrl] + '?a=' + this.applicationName;
        }
        else {
            this.composedUrl = this.functionUrls['direct'] + '?a=' + this.applicationName;
        }
    }
    doTracking() {
        const random = Math.floor(Math.random() * this.sampleRate) + 1;
        return random == this.sampleRate;
    }
    sdkHandler(response) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.tracker(response);
        });
    }
    siteBuilderTracker(data, slug) {
        return __awaiter(this, void 0, void 0, function* () {
            const raw = JSON.stringify({
                type: 'SiteBuilder',
                data,
                app: this.applicationName,
                space: this.spaceId,
                slug
            });
            if (this.doTracking()) {
                try {
                    yield fetch(this.composedUrl, {
                        method: 'POST',
                        body: raw
                    });
                }
                catch (e) { }
            }
            return Promise.resolve();
        });
    }
    GQLTracker(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const raw = JSON.stringify({
                type: 'GraphQL',
                data,
                app: this.applicationName,
                space: this.spaceId,
            });
            if (this.doTracking()) {
                try {
                    yield fetch(this.composedUrl, {
                        method: 'POST',
                        body: raw
                    });
                }
                catch (e) { }
            }
            return Promise.resolve();
        });
    }
    fullyTracker(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const raw = JSON.stringify({
                type: 'Contentfully',
                data,
                app: this.applicationName,
                space: this.spaceId
            });
            if (this.doTracking()) {
                try {
                    yield fetch(this.composedUrl, {
                        method: 'POST',
                        body: raw
                    });
                }
                catch (e) { }
            }
            return Promise.resolve();
        });
    }
    tracker(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const raw = JSON.stringify({
                type: 'Standard',
                data,
                app: this.applicationName,
                space: this.spaceId
            });
            if (this.doTracking()) {
                try {
                    yield fetch(this.composedUrl, {
                        method: 'POST',
                        body: raw
                    });
                }
                catch (e) { }
            }
            return Promise.resolve();
        });
    }
}
module.exports = Tracker;
